import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {NGXLogger} from 'ngx-logger';
import {environment} from '../../../../../../../../environments';
import {ManufacturerListPayload, ManufacturerListResponse} from './manufacturer.models';

@Injectable({
  providedIn: 'root'
})
export class ManufacturerDataService {

  constructor(private http: HttpClient, private logger: NGXLogger) {
  }

  load(): Observable<ManufacturerListPayload> {
    return this.http.get<ManufacturerListResponse>(`${environment.api}/manufacturers`).pipe(
      map((res) => ({items: res.datalist, rows: res.rows}))
    );
  }
}
